module.exports = __webpack_public_path__ + "media/img/illustrations/scale-37763086bab3d2ed547046c1f0f9f6e4.svg";